import { USER_STUB } from '../../tests/fixtures/stubs/user';
export const coderNotes = {
    isDrawerOpen: false,
    isOpen: false,
    servicesLoading: false,
    coderNotesParams: {},
    activeUser: USER_STUB,
    coderNotesList: [],
    coderNote: ''
};
